module.exports = __webpack_public_path__ + "static/media/lightbulb-dollar.210db8e0.svg";